import { useContext } from "react";

// Redux
import { useSelector } from "react-redux";

// MUI
import { Grid } from "@mui/material";

// Context
import { OEMContext } from "@DataPages/context/oem/OEMContext";

// Components
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

export default function CarBrands() {
	const { franchise, setFranchise } = useContext(OEMContext);
	const location = useSelector((state) => state.location.location);
	const handleOnChange = ({ id }) => setFranchise(id);

	const allFranchises = location?.franchises.map((brand) => ({
		id: brand,
		label: brand,
	}));

	return (
		<Grid item sx={{ minWidth: "150px" }}>
			<SmartSelector
				selectBy={"id"}
				options={allFranchises || []}
				selected={franchise}
				onChangeAction={(selected) => handleOnChange(selected)}
			/>
		</Grid>
	);
}
